import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, map, Observable, of } from "rxjs";
import { UserDetails } from "./model/user";
import { Router } from "@angular/router";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  /**
   * Redirects to Fifa login page
   */
  login(): void {
    window.open(`${environment.prestoUrl}/api/auth/redirect`, '_self');
  }

  /**
   * Clear up user session and redirects to logout page
   */
  logout(): void {
    this.clearCookie();
    sessionStorage.clear();

    const url = `${environment.prestoUrl}/logout`;
    this.http.post<any>(url, {})
      .subscribe(() => this.router.navigate(['/signout']))
  }

  /**
   * Requests user information from backend
   * @returns User information
   */
  authenticate(): Observable<Readonly<UserDetails>> {
    const url = `${environment.prestoUrl}/users/me`;
    return this.http.get<UserDetails>(url).pipe(
      map((prestoUser) => {
        const user: UserDetails = {
          username: prestoUser.username,
          firstName: prestoUser.firstName,
          lastName: prestoUser.lastName,
          outlets: prestoUser.outlets,
          languageIso: prestoUser.languageIso
        };
        return user;
      })
    );
  }

  private clearCookie(): void {
    document.cookie.split(';').forEach((segment) => {
      document.cookie = segment.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
  }
}
